import { render, staticRenderFns } from "./foreignArea.vue?vue&type=template&id=22b90fd0"
import script from "./foreignArea.vue?vue&type=script&lang=js"
export * from "./foreignArea.vue?vue&type=script&lang=js"
import style0 from "./foreignArea.vue?vue&type=style&index=0&id=22b90fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports